//判断横屏竖屏
function checkDirect() {
    if (
      document.documentElement.clientWidth >=
      document.documentElement.clientHeight
    ) {
      return "landscape"; //横屏
    } else {
      return "portrait"; //竖屏
    }
}
//显示屏幕方向提示浮层
function orientNotice() {
    var orient = checkDirect();
    if (orient == "landscape") {
        document.querySelector("#orientLayer").style.display = "block";
    } else {
        document.querySelector("#orientLayer").style.display = "none";
    }
}
//给屏幕添加监听事件
function screenDirection(fn) {
    orientNotice();
    window.addEventListener(
        "onorientationchange" in window ? "orientationchange" : "resize",
        function () {
            setTimeout(orientNotice, 200);
        }
    );
}

export default screenDirection